
import { Placement } from '@post-office/placements-frontend/software-timeline-placement';
export default Placement;
